import { useState, useEffect, useCallback } from 'react';

const ACTIVE_INTERVAL = 10_000;    // 10s when tab focused + recent activity
const IDLE_INTERVAL = 60_000;      // 60s when tab visible but idle
const HIDDEN_INTERVAL = 120_000;   // 2min when tab hidden
const IDLE_THRESHOLD = 60_000;     // consider idle after 60s of no mouse/keyboard

export function useAdaptivePolling(): number {
  const [interval, setInterval_] = useState(ACTIVE_INTERVAL);

  const update = useCallback(() => {
    if (document.hidden) {
      setInterval_(HIDDEN_INTERVAL);
      return;
    }

    const lastActivity = Number(sessionStorage.getItem('_lastActivity') || '0');
    const idleMs = Date.now() - lastActivity;

    setInterval_(idleMs > IDLE_THRESHOLD ? IDLE_INTERVAL : ACTIVE_INTERVAL);
  }, []);

  useEffect(() => {
    const markActive = () => {
      sessionStorage.setItem('_lastActivity', String(Date.now()));
      update();
    };

    // Set initial activity
    markActive();

    window.addEventListener('mousemove', markActive, { passive: true });
    window.addEventListener('keydown', markActive, { passive: true });
    document.addEventListener('visibilitychange', update);

    const timer = window.setInterval(update, 5000);

    return () => {
      window.removeEventListener('mousemove', markActive);
      window.removeEventListener('keydown', markActive);
      document.removeEventListener('visibilitychange', update);
      window.clearInterval(timer);
    };
  }, [update]);

  return interval;
}
